export default __webpack_public_path__ + "static/media/legal-3.8403ccdf.jpg";